
export enum DatePeriod {
  THIS_WEEK = 'THIS_WEEK',
  LAST_WEEK = 'LAST_WEEK',
  THIS_MONTH = 'THIS_MONTH',
  LAST_MONTH = 'LAST_MONTH',
  THIS_YEAR = 'THIS_YEAR',
  LAST_YEAR = 'LAST_YEAR',
  LAST_30_DAYS = 'LAST_30_DAYS',
  ROLLING_12_MONTHS = 'ROLLING_12_MONTHS',
  YESTERDAY = 'YESTERDAY',
  CUSTOM_RANGE = 'CUSTOM_RANGE',
}

export enum RangeLabel {
  THIS_WEEK = 'This Week',
  LAST_WEEK = 'Last Week',
  THIS_MONTH = 'This Month',
  LAST_MONTH = 'Last Month',
  THIS_YEAR = 'This Year',
  LAST_YEAR = 'Last Year',
  THIS_FINANCIAL_YEAR = 'This Financial Year',
  LAST_FINANCIAL_YEAR = 'Last Financial Year',
  CUSTOM_RANGE = 'Custom Range',
  YESTERDAY = 'Yesterday',
  ROLLING_12_MONTHS = '12 Month Rolling',
}
